import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Categoria } from 'src/app/model/index.model';
import Swal from 'sweetalert2';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { CategoriaService } from 'src/app/service/index.service';
import { FilCategoriaComponent } from '../../filtro/fil-categoria/fil-categoria.component';

@Component({
  selector: 'app-lst-categoria',
  templateUrl: './lst-categoria.component.html',
  styleUrls: ['./lst-categoria.component.css']
})
export class LstCategoriaComponent implements OnInit {

  @ViewChild(FilCategoriaComponent, { static: true }) fil: FilCategoriaComponent;
  entity = "Categorias"

  items: Categoria[];
  item: Categoria;

  proccess: Boolean;

  constructor(private wsdl: CategoriaService, private router: Router) {
    this.item = new Categoria();
  }

  ngOnInit() {

  }

  preNew() {
    this.item = new Categoria();
  }

  select(item: Categoria) {
    this.item = item;
  }

  cancel() {
    this.item = new Categoria();
    this.fil.list();
  }

  async setResultCancel(event: boolean) {
    UturuncoUtils.showToas("Operación cancelada", "info");
  }

  setResult(event: any) {
    this.cancel();
  }

  preDelete(item: Categoria) {
    this.item = new Categoria();
    this.item = item;

    Swal.fire({
      title: 'Esta Seguro?',
      text: '¡No podrás recuperar este archivo ' + item.nombre + '!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '¡Sí, bórralo!',
      cancelButtonText: 'No, mantenlo',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.value) {
        this.delete()
      } else if (result.dismiss === Swal.DismissReason.cancel) {

        UturuncoUtils.showToas('Tu archivo esta seguro :)', "warning")

      }
    })
  }

  async delete() {
    try {
      this.proccess = true;
      const res = await this.wsdl.doDelete(this.item.id).then();
      const result = JSON.parse(JSON.stringify(res));
      if (result.code == 200) {
        UturuncoUtils.showToas(result.msg, "success");
        this.cancel();
      } else {
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
    }
    this.proccess = false;
  }

  doFound(event: Categoria[]) {
    this.items = event;
  }

  linkear(id?: number) {
    this.router.navigateByUrl("admin/" + this.entity.toLocaleLowerCase() + "/abm/" + id);
  }

}
